import { Award } from "lucide-react";

export const BADGE_STYLES = [
  { ring: "#B87333", bg: "linear-gradient(145deg,#E3A16B,#8C4A1E)" },
  { ring: "#9CA3AF", bg: "linear-gradient(145deg,#F3F4F6,#8A939E)" },
  { ring: "#D4A017", bg: "linear-gradient(145deg,#FDE68A,#B7791F)" },
];

export const Medal = ({ i, earned = true, size = 40, testId }) => (
  <span data-testid={testId}
    className={`relative inline-grid place-items-center rounded-full shrink-0 ${earned ? "" : "grayscale opacity-35"}`}
    style={{ width: size, height: size, background: BADGE_STYLES[i].bg, boxShadow: `0 0 0 2px ${BADGE_STYLES[i].ring}, 0 6px 14px -6px rgba(0,0,0,0.5)` }}>
    <Award className="text-white drop-shadow" style={{ width: size * 0.55, height: size * 0.55 }} />
  </span>
);
